module.exports = __webpack_public_path__ + "img/base_audio.9b2bdb34.svg";